import { Pill } from '../../layout/Pill.jsx';
import { useSessionDuration } from './useSessionDuration.js';

/**
 * شارة مدة الباقة لشاشة الأطفال داخل القاعة.
 *
 * داخل المدة  → «متبقٍ hh:mm:ss» بالأخضر.
 * بعد انتهائها → «تجاوز المدة hh:mm:ss» بالأحمر — لا عدّاد يستمر بصمت ولا رقم
 *               سالب. الجلسة تبقى نشطة والوقت الإضافي يُفوتَر عند المحاسبة.
 * بلا مدة (ساعي/ثابت/مفتوح/اشتراك شهري) → لا شيء.
 */
export function SessionDurationBadge({ session, showRemaining = true }) {
  const d = useSessionDuration(session);
  if (!d.hasDuration) return null;
  if (d.isOver) {
    return (
      <Pill variant="danger" className="!px-1.5 !py-0 !text-[10.5px] font-mono">
        تجاوز المدة {d.over}
      </Pill>
    );
  }
  if (!showRemaining) return null;
  return (
    <Pill variant="success" className="!px-1.5 !py-0 !text-[10.5px] font-mono">
      متبقٍ {d.remaining}
    </Pill>
  );
}

/** نصّ العدّاد وحده: المتبقّي داخل المدة، وزمن التجاوز بعدها. */
export function SessionDurationText({ session }) {
  const d = useSessionDuration(session);
  if (!d.hasDuration) return <span className="font-mono">{d.elapsed}</span>;
  return (
    <span className="font-mono" style={{ color: d.isOver ? '#B91C1C' : undefined }}>
      {d.isOver ? `+${d.over}` : d.remaining}
    </span>
  );
}

export default SessionDurationBadge;
